// Envelope icon used as the hero on EmailVerifyScreen. `currentColor` drives
// both strokes — set `color: var(--bg)` when sitting on an ink-color tile.
// Sourced from for-engineering-auth/assets/icon-email.svg.

import type { SVGProps } from 'react';

export function EmailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label="Email"
      {...props}
    >
      <rect x="3" y="7" width="26" height="18" stroke="currentColor" strokeWidth="2" />
      <path d="M3 8 L16 18 L29 8" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
